.root {
  position: var(--haus-carticon__root__position, absolute);
  top: var(--haus-carticon__root__top, 0);
  left: var(--haus-carticon__root__left, 0);
  width: var(--haus-carticon__root__width, 100%);
  height: var(--haus-carticon__root__height, 100%);
  display: var(--haus-carticon__root__display, block);
  pointer-events: var(--haus-carticon__root__pointer-events, none);
}

.cartBadge {
  position: var(--haus-carticon__cartBadge__position, absolute);
  right: var(--haus-carticon__cartBadge__right, -1px);
  top: var(--haus-carticon__cartBadge__top, -1px);
  display: var(--haus-carticon__cartBadge__display, flex);
  width: var(--haus-carticon__cartBadge__width, fit-content);
  min-width: var(--haus-carticon__cartBadge__min-width, 12px);
  height: var(--haus-carticon__cartBadge__height, 12px);
  justify-content: var(--haus-carticon__cartBadge__justify-content, center);
  align-items: var(--haus-carticon__cartBadge__align-items, center);
  background-color: var(
    --haus-carticon__cartBadge__background-color,
    var(--haus-color-primary, rgb(22, 159, 219))
  );
  color: var(--haus-carticon__cartBadge__color, var(--haus-color-body, #fafafa));
  font-family: var(
    --haus-carticon__cartBadge__font-family,
    var(--haus-typography-body-font-family, 'Inter', sans-serif)
  );
  font-size: var(--haus-carticon__cartBadge__font-size, 11px);
  padding: var(--haus-carticon__cartBadge__padding, 2px);
  font-style: var(--haus-carticon__cartBadge__font-style, normal);
  font-weight: var(--haus-carticon__cartBadge__font-weight, 700);
  border-radius: var(--haus-carticon__cartBadge__border-radius, 12px);
  animation: pulse 2s 1;
}

.cartButton {
  all: unset;
  cursor: var(--haus-carticon__cartButton__cursor, pointer);
  width: var(--haus-carticon__cartButton__width, 100%);
  height: var(--haus-carticon__cartButton__height, 100%);
  display: var(--haus-carticon__cartButton__display, block);
  position: var(--haus-carticon__cartButton__position, relative);
  background-color: var(--haus-carticon__cartButton__background-color, transparent);
  border-radius: var(--haus-carticon__cartButton__border-radius, 50%);
  pointer-events: var(--haus-carticon__cartButton__pointer-events, auto);

  &:hover {
    background: var(--haus-carticon__cartButton__hover__background, transparent);
  }

  &:focus-visible {
    outline: var(
      --haus-carticon__cartButton__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(--haus-carticon__cartButton__focus-visible__outline-offset, 2px);
    box-shadow: var(
      --haus-carticon__cartButton__focus-visible__box-shadow,
      0 0 0 2px var(--haus-color-background, #fff)
    );
  }
}

@keyframes pulse {
  0% {
    transform: var(--haus-carticon__icon__pulse-start-transform, scale(1));
    box-shadow: var(
      --haus-carticon__icon__pulse-start-box-shadow,
      0 0 0 0 rgba(116, 151, 155, 0.7)
    );
  }

  30% {
    transform: var(--haus-carticon__icon__pulse-peak-transform, scale(1.25));
  }

  70% {
    transform: var(--haus-carticon__icon__pulse-dip-transform, scale(0.95));
    box-shadow: var(--haus-carticon__icon__pulse-dip-box-shadow, 0 0 0 10px rgba(116, 151, 155, 0));
  }

  100% {
    transform: var(--haus-carticon__icon__pulse-end-transform, scale(1));
    box-shadow: var(--haus-carticon__icon__pulse-end-box-shadow, 0 0 0 0 rgba(116, 151, 155, 0));
  }
}
